<template>
  <button @click="cargueMasivo()"
          class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="inline-block w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
    </svg>
    <span class="ml-3">Cargue masivo</span>
  </button>
  <!--  CARGUE MASIVO-->
  <div class="hidden">
    <div class="max-w-xl" id="cargue_masivo">
      <a type="button" :href="`${baseUrl}/assets/informes_rendimientos/plantilla_cargue_masivo_extractos_bancarios.xlsx`" download="plantilla_cargue_masivo_extractos_bancarios.xlsx"
         class="rounded-md border my-3 mr-3 float-right border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="text-white self-center w-6 h-6 inline-block text-gray-600"
             fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
        <span class="ml-3">Descargar plantilla</span>
      </a>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full my-3">
        <div class="w-full">
          <label for="year" class="block text-sm font-medium text-gray-700">Año <span
              class="text-red-700 font-bold">*</span></label>
          <input type="number" step="1" min="1920" id="year" v-model="formMasivo.year"
                 class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="w-full">
          <label for="mes" class="block text-sm font-medium text-gray-700">Mes <span
              class="text-red-700 font-bold">*</span></label>
          <select v-model="formMasivo.mes"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option value="" selected>Seleccione un mes...</option>
            <option v-for="(nameMonth, key, index) in nameMonths" :value="parseInt(key)+1" :key="'E'+index">
              {{ nameMonth }}
            </option>
          </select>
        </div>
        <template v-if="formMasivo.year && formMasivo.mes">
          <div class="w-full">
            <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del banco <span
                class="text-red-700 font-bold">*</span></label>
            <select id="banco_id"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    :value="formBancoTasaEfectivaAnual.banco_id"
                    @change="(idBancoNew)=>$emit('updateBancoId', {'banco_id': idBancoNew.target.value})">
              <option value="" selected>Seleccione un banco...</option>
              <option v-for="(cuentaBancaria, index) of arregloBancos" :key="'F'+index" :value="cuentaBancaria.banco.id">  
              {{
                  cuentaBancaria.banco.nombre_banco 
                }}
              </option>
            </select>
          </div>
          <template v-if="formBancoTasaEfectivaAnual.banco_id">
            <div class="w-full">
              <label for="cuenta_bancaria_id" class="block text-sm font-medium text-gray-700">Cuenta bancaria <span
                  class="text-red-700 font-bold">*</span></label>
              <select id="cuenta_bancaria_id"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      v-model="formMasivo.cuenta_bancaria_id">
                <option value="" selected>Seleccione una cuenta bancaria...</option>
                <option v-for="(cuentaBancaria, index) of cuentasBancarias.filter(cuentaBancaria => cuentaBancaria.banco_id === formBancoTasaEfectivaAnual.banco_id)" :key="'G'+index" :value="cuentaBancaria.id">
                  {{
                    `${cuentaBancaria.cuenta_bancaria} (${cuentaBancaria.nombre_cuenta})`
                  }}
                </option>
              </select>
            </div>
            <template v-if="formMasivo.cuenta_bancaria_id">
              <div class="w-full">
                <label for="banco_tasa_efectiva_anual_id" class="block text-sm font-medium text-gray-700">Tasa E.A.
                  Vigente
                  del banco</label>
                <input type="text" id="banco_tasa_efectiva_anual_id"
                      :value="tasaEA?'%'+tasaEA.tasa_efectiva_anual:'No hay una Tasa E.A. vigente activa'" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
              </div>
            </template>
          </template>
        </template>
        <div class="w-full">
          <label for="saldo_inicial" class="block text-sm font-medium text-gray-700">Saldo inicial <span
              class="text-red-700 font-bold">*</span></label>
          <input v-model="formMasivo.saldo_inicial" id="saldo_inicial"
                 class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                 type="text"/>
        </div>
      </div>
      <div class="mt-3">
        <template v-if="!(formMasivo.year && formMasivo.mes)">
          <p class="text-left"><b>IMPORTANTE: </b></p>
          <p class="text-left">- Debe ingresar el mes y el año para seleccionar el banco correspondiente
            al extracto bancario.
          </p>
        </template>
        <template v-else>
          <template v-if="!formBancoTasaEfectivaAnual.banco_id&&cuentasBancarias.length">
            <p class="text-left"><b>IMPORTANTE: </b></p>
            <p class="text-left">- Debe seleccionar una cuenta bancaria para cargar la <b>Tasa Efectiva
              Anual</b></p>
          </template>
          <template v-else-if="!cuentasBancarias.length">
            <p class="text-left"><b><span class="text-yellow-500">ADVERTENCIA: </span></b></p>
            <p class="text-left">- No hay cuentas bancarias que tengan una <b>Tasa
              E.A.</b> registrados para el mes y año
              indicado. <b>Es necesario registrarlo para continuar.</b>
            </p>
          </template>
        </template>
      </div>
      <div class="my-3">
        <p class="text-left font-bold">Nota:</p>
        <p class="text-left"><b>-</b> Los campos con <span class="text-red-700">*</span> son requeridos.</p>
        <p class="text-left"><b>-</b> Si el saldo inicial es un egreso, el valor debe ser negativo (-).</p>
        <p class="text-left"><b>-</b> Los números con decimales deben ir separados por un punto.</p>
        <p class="text-left me-3"><b>EJ:</b> 51200.50</p>
      </div>
      <label style="min-height: 8rem;" for="archivo"
             class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
        <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
               stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
          <span class="font-medium text-gray-600 grow">
          Arrastra el archivo aquí, o
          <span class="text-blue-600 underline">abre el explorador</span>
          </span>
        </span>
        <span ref="fileFormDrop" id="drag_over" class="hidden">
            <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                 fill="none"
                 viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
            </svg>
        </span>
        <span ref="fileFormUploaded" id="info_archivo" class="hidden">
          <img id="preview_archivo" src="" alt=""/>
          <span class="flex justify-center align-middle gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
            </svg>
            <span id="nombre_archivo" class="self-center"></span>
          </span>
        </span>
        <input type="file" id="archivo"
               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
               class="hidden" @change="
               uploadFile(document.getElementById('archivo').files.item(0));
               file=document.getElementById('archivo').files.item(0);">
      </label>
    </div>
  </div>
</template>

<script>
import { nextTick, ref, watch } from "vue";
import { monthNames, swal } from "@/common/constants/variables";
import { generateTextError, verifyHttpCode, useAPIRest, removeFile, uploadFile } from "@/common/constants";
import { separateNumberByCommaInput, enableUploadFileByDragger } from "@/common/constants/functions";
export default {
  name: 'ReservasChildHeaderComponent',
  props: ['authToken', 'view', 'formBancoTasaEfectivaAnual', 'cuentasBancarias','arregloBancos', 'tasaEA', 'listarCuentasBancariasPorMesYear', 'listarTasasEA','refreshData'],
  emits: ['updateValues', 'customSaveData', 'updateBancoId'],
  async setup(props, {emit}) {
    const baseUrl = window.location.origin;
    const formMasivo = ref({
      banco_id: '',
      tasa_e_a_id: '',
      cuenta_bancaria_id: '',
      year: '',
      mes: '',
      saldo_inicial: ''
    });
    const file = ref(undefined);
    const informacionCalculoMovimientos = ref([]);
    const nameMonths = {...monthNames};
    let alertCargueMasivo = '';
    let listIngresos = [];
    let listEgresos = [];
    const cargueMasivo = async () => {
      if (!alertCargueMasivo) {
        alertCargueMasivo = document.getElementById('cargue_masivo');
        document.getElementById('cargue_masivo').remove();
      }
      await swal.fire({
        html: alertCargueMasivo,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Cargar archivo',
        customClass: {
          actions: 'm-0'
        },
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          formMasivo.value.tasa_e_a_id = props.tasaEA.id;
          formMasivo.value.saldo_inicial = formMasivo.value.saldo_inicial.replaceAll(',', '');
          const valuesRequired = [formMasivo.value.cuenta_bancaria_id, formMasivo.value.year, formMasivo.value.mes, formMasivo.value.saldo_inicial];
          if (Object.values(valuesRequired).filter(valor => !valor).length) await swal.fire('Por favor rellene todos los campos requeridos', '', 'error');
          else if (!formMasivo.value.tasa_e_a_id) await swal.fire({
            title: 'Es necesario una Tasa E.A. vigente del banco',
            html: '<b>Importante:</b> Asegurate de haber seleccionado el año, mes y el banco del extracto, para seleccionar la Tasa E.A. vigente.',
            icon: 'error'
          });
          else {
            const archivoCargado = file.value;
            if (archivoCargado) {
              const extenciones_excel_validas = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
              if (extenciones_excel_validas.includes(archivoCargado.type)) {
                // ENVIAR ARCHIVO AL BACKEND Y PROCESAR LOS DATOS, DE TAL MANERA QUE SE ENVIÉ LO ESPERADO AL ENDPOINT DE CALCULAR EXTRACTOS.
                const formData = new FormData();
                formData.append('form', JSON.stringify(formMasivo.value));
                formData.append('file', archivoCargado, archivoCargado.name);
                const cargarExtracto = async (formData, authToken) => await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS_CARGUEEXTRACTO, 'POST', authToken, formData, undefined, 'auto').then(async resJSON => {
                  const {statusCode} = resJSON;
                  const textoError = generateTextError(resJSON);
                  if (verifyHttpCode(statusCode, 'success')) {
                    delete resJSON.statusCode;
                    return resJSON;
                  } else {
                    if (textoError === 'El extracto bancario ya se encuentra registrado') {
                      return await swal.fire({
                        title: textoError,
                        html: '<p>Si continua, todos los movimientos del extracto que ya se encuentran registrados en el sistema, serán eliminados y en su lugar se agregarán los movimientos del extracto que se encuentran en el Excel. <span><b>¿Desea continuar?</b></span></p>',
                        icon: 'warning',
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonText: 'Continuar de todos modos',
                        cancelButtonText: 'Cancelar',
                        showLoaderOnConfirm: true,
                        preConfirm: async () => {
                          formData.append('responseError', JSON.stringify(resJSON));
                          return await cargarExtracto(formData, props.authToken);
                        },
                        allowOutsideClick: () => !swal.isLoading()
                      }).then(result => result.value);
                    } else await swal.fire(textoError, '', 'error');
                  }
                });
                return await cargarExtracto(formData, props.authToken);
              } else await swal.fire('¡Solo se admiten archivos Excel con el formato .xls, xlsx o .csv!', '', 'error');
            } else await swal.fire('¡No se cargo ningun archivo!', '', 'error');
          }
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (result) => {
        if (result.isConfirmed && result.value !== true) {
          const resJSON = result.value;
          const {statusCode} = resJSON;
          delete resJSON['statusCode'];
          if (verifyHttpCode(statusCode, 'errorServer')) await swal.fire('Error inesperado. Informar al administrador.', '', 'error');
          else {
            emit('customSaveData', {'informacionCalculoMovimientos': result.value});
            for (const value of Object.values(result.value[formMasivo.value.year][formMasivo.value.mes]['movimientos'])) {
              const {ingreso, egreso} = value;
              listIngresos.push(ingreso);
              listEgresos.push(egreso);
            }
            emit('customSaveData', {'listIngresos': listIngresos});
            emit('customSaveData', {'listEgresos': listEgresos});
            await swal.fire({
              title: '¡Extracto generado con exito!',
              html: '<p>¿Desea realizar el cálculo de los intereses del extracto registrado?</p>',
              icon: 'warning',
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText: '¡Realizar calculo!',
              cancelButtonText: 'Cancelar'
            }).then(async result => {
              if (result.isConfirmed) emit('updateValues', {'view':'calcularExtracto'})
            });
            await props.refreshData();
            limpiarFormulario(formMasivo.value, true);
          }
        }
      });
      limpiarFormulario(null, true);
    };
    const limpiarFormulario = (form = null, limpiarArchivo = false) => {
      if(form) for (const data in form) {
        form[data] = '';
      }
      if (limpiarArchivo) {
        removeFile(alertCargueMasivo);
        file.value = undefined;
      }
    }
    watch(() => ({...formMasivo.value}), async (newFormMasivo, oldFormMasivo) => {
      if (newFormMasivo.mes && newFormMasivo.year && (oldFormMasivo.mes !== newFormMasivo.mes || oldFormMasivo.year !== newFormMasivo.year)){
        formMasivo.value.tasa_e_a_id = '';
        await props.listarCuentasBancariasPorMesYear(props.authToken, 1, 'created_at', 'ASC', '', '', `table.estado = 1, table.year = ${newFormMasivo.year}, table.mes = ${newFormMasivo.mes}`, false);
      }
    });
    watch(() => formMasivo.value.cuenta_bancaria_id, async (newCuentaBancariaId) => {
      if(newCuentaBancariaId)
      await props.listarTasasEA(props.authToken, 1, 'created_at', 'ASC', '', '', `table.cuenta_bancaria_id=${newCuentaBancariaId}, table.estado = 1, table.year = ${formMasivo.value.year}, table.mes = ${formMasivo.value.mes}`, false);
    })
    watch(() => formMasivo.value.saldo_inicial, (newSaldoInicial) => {
      nextTick(() => formMasivo.value.saldo_inicial = separateNumberByCommaInput(newSaldoInicial));
    })
    watch(() => props.formBancoTasaEfectivaAnual.banco_id, async () => {
      formMasivo.value.cuenta_bancaria_id = '';
    });
    watch(() => file.value, (newFile) => {
        if (newFile && window.navigator.userAgent.includes("Firefox")) {
          const name = newFile.name;
          const mimeType = newFile.type;
          const lastDot = name.lastIndexOf('.');
          const fileName = name.substring(0, lastDot);
          const ext = name.substring(lastDot + 1);
          if (ext === 'csv' && mimeType !== 'text/csv') file.value = new File([newFile], `${fileName}.${ext}`, {type: 'text/csv'});
        }
    });
    return {
      formMasivo,
      nameMonths,
      file,
      informacionCalculoMovimientos,
      listIngresos,
      listEgresos,
      cargueMasivo,
      uploadFile,
      document,
      baseUrl,
    }
  },
  mounted() {
    enableUploadFileByDragger(this);
  }
}
</script>